import React, { useEffect, useState } from "react";
import { Box, Typography, Stack, TextField, Button, Grid } from "@mui/material";
import { Email, Phone, LocationOn } from "@mui/icons-material";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { motion } from "framer-motion"; 

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    // This effect handles scrolling and URL hash cleaning on component mount.
    window.scrollTo(0, 0);
    if (window.location.hash) {
      window.history.replaceState(null, null, " ");
    }
  }, []);

  const handleSubmit = () => {
    console.log("formData:======>>>", formData);
  };

  // Define the animation variant for a smooth fade-in from the top
  const fadeInFromTopVariant = {
    hidden: { opacity: 0, y: -50 }, // Starts invisible and 50px above its final position
    visible: {
      opacity: 1, // Becomes fully visible
      y: 0, // Moves to its natural Y position
      transition: {
        duration: 0.8, // Animation takes 0.8 seconds
        ease: "easeOut", // A smooth easing function
      },
    },
  };

  return (
    <Box
      component="section"
      aria-label="Contact Us - Vertex Suite"
      sx={{
        display: "flex",
        justifyContent: "center",
        py: { xs: 2, sm: 3, md: 3, lg: 3.5 },
        px: { xs: 2, sm: 3, md: 4, lg: 6 },
      }}
    >
      <motion.div
        initial="hidden" 
        whileInView="visible" 
        viewport={{ once: true, amount: 0.3 }} 
        variants={fadeInFromTopVariant} 
        style={{
          width: "100%", 
          maxWidth: "1280px", 
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 4,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)", 
            overflow: "hidden", 
            maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
          }}
          mb={{ xs: 1.5, sm: 2, md: 5, lg: 5 }} 
          mt={{ xs: 0, sm: 0, md: 5, lg: 5 }} 
        >
          <Grid container spacing={0}>
            {/* Left Column: Contact Information */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                backgroundColor: "#f5f8fd", 
                p: { xs: 3, sm: 4, md: 5 }, 
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", 
              }}
            >
              <Stack spacing={2} mb={{ xs: 1.5, sm: 2, md: 2 }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: { xs: "22px", sm: "36px", md: "30px" },
                      backgroundColor: "#054E91",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                      mr: 2, 
                    }}
                  />
                  <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                      fontSize: { xs: "22px", sm: "28px", md: "30px" },
                      color: "#054E91",
                      fontFamily: "'Roboto', sans-serif",
                      fontWeight: 600,
                      letterSpacing: "0.5px",
                    }}
                  >
                    Get in touch
                  </Typography>
                </Stack>

                <Typography
                  sx={{
                    fontSize: { xs: "15px", sm: "17px", md: "20px" },
                    lineHeight: { xs: 1.5, sm: 1.8, md: 1.2 },
                    fontFamily: "'Roboto', sans-serif",
                    color: "text.secondary",
                    letterSpacing: "0.3px",
                  }}
                >
                  We are here to help. Reach out with your queries, ideas, or
                  support needs- our team will respond promptly.
                </Typography>
              </Stack>

              {/* Corporate Address Block */}
              <Stack direction="row" alignItems="flex-start" spacing={2} mb={2}>
                <Box
                  sx={{
                    backgroundColor: "#054E91",
                    borderRadius: "50%",
                    p: 0.6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LocationOn sx={{ color: "#fff", fontSize: 16 }} />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "'Roboto', sans-serif",
                      color: "#333",
                    }}
                  >
                    Corporate office address:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      width: { xl: "70%" },
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "text.secondary",
                      ml: "2px",
                    }}
                  >
                    H.O. Block-86, Plot-2, Nehru Nagar East, Bhilai,
                    Chhattisgarh 490020
                  </Typography>
                </Box>
              </Stack>

              {/* Email Block */}
              <Stack direction="row" alignItems="flex-start" spacing={2} mb={2}>
                <Box
                  sx={{
                    backgroundColor: "#054E91",
                    borderRadius: "50%",
                    p: 0.6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Email sx={{ color: "#fff", fontSize: 16 }} />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "'Roboto', sans-serif",
                      color: "#333",
                    }}
                  >
                    Email Us
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "text.secondary",
                    }}
                  >
                    info@atmikbharat.com
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "text.secondary",
                    }}
                  >
                    hello@yourdomain.id
                  </Typography>
                </Box>
              </Stack>

              {/* Call Block */}
              <Stack direction="row" alignItems="flex-start" spacing={2} mb={2}>
                <Box
                  sx={{
                    backgroundColor: "#054E91",
                    borderRadius: "50%",
                    p: 0.6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Phone sx={{ color: "#fff", fontSize: 15 }} />
                </Box>
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      fontFamily: "'Roboto', sans-serif",
                      color: "#333",
                    }}
                  >
                    Call Us
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "text.secondary",
                    }}
                  >
                    Phone: +91-7349064541
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontFamily: "'Roboto', sans-serif",
                      color: "text.secondary",
                    }}
                  >
                    Fax: +6221.2002.2013
                  </Typography>
                </Box>
              </Stack>

              {/* Social Media Links */}
              <Box mt={1}>
                <Typography
                  fontWeight={600}
                  mb={1}
                  fontSize="18px"
                  fontFamily="'Roboto', sans-serif"
                  color="#333"
                >
                  Follow our social media
                </Typography>
                <Stack direction="row" spacing={2}>
                  {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map(
                    (Icon, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          backgroundColor: "#054E91",
                          borderRadius: "50%",
                          p: 0.6,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          transition: "transform 0.2s ease-in-out",
                          "&:hover": {
                            transform: "scale(1.1)", // Slight scale effect on hover
                          },
                        }}
                      >
                        <Icon style={{ color: "#fff", fontSize: 16 }} />
                      </Box>
                    )
                  )}
                </Stack>
              </Box>
            </Grid>

            {/* Right Column: Enquiry Form */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                backgroundColor: "#fff", 
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", 
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                mb={{ xs: 1.5, sm: 2, md: 2 }}
              >
                <Box
                  sx={{
                    width: "6px",
                    height: { xs: "22px", sm: "36px", md: "30px" },
                    backgroundColor: "#054E91",
                    borderTopRightRadius: "6px",
                    borderBottomRightRadius: "6px",
                    mr: 2,
                  }}
                />
                <Typography
                  variant="h4"
                  component="h2"
                  sx={{
                    fontSize: { xs: "22px", sm: "28px", md: "30px" },
                    color: "#054E91",
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                  }}
                >
                  Send us a message
                </Typography>
              </Stack>

              <Grid container spacing={2}>
                {/* Name Input */}
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontWeight: 500, mb: 0.5 }}>
                    Name
                  </Typography>
                  <TextField
                    placeholder="Enter your name"
                    fullWidth
                    variant="outlined"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    InputProps={{
                      sx: {
                        backgroundColor: "#f5f8fd", // Light background for text fields
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                {/* Company Input */}
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontWeight: 500, mb: 0.5 }}>
                    Company
                  </Typography>
                  <TextField
                    placeholder="Enter company name"
                    fullWidth
                    variant="outlined"
                    value={formData.company}
                    onChange={(e) =>
                      setFormData({ ...formData, company: e.target.value })
                    }
                    InputProps={{
                      sx: {
                        backgroundColor: "#f5f8fd",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                {/* Phone Input */}
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontWeight: 500, mb: 0.5 }}>
                    Phone
                  </Typography>
                  <TextField
                    placeholder="Enter your phone number"
                    fullWidth
                    variant="outlined"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                    InputProps={{
                      sx: {
                        backgroundColor: "#f5f8fd",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                {/* Email Input */}
                <Grid item xs={12} sm={6}>
                  <Typography sx={{ fontWeight: 500, mb: 0.5 }}>
                    Email
                  </Typography>
                  <TextField
                    placeholder="Enter your email"
                    fullWidth
                    variant="outlined"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    InputProps={{
                      sx: {
                        backgroundColor: "#f5f8fd",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                {/* Message Input (Multiline) */}
                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: 500, mb: 0.5 }}>
                    Message
                  </Typography>
                  <TextField
                    placeholder="Write your message here"
                    fullWidth
                    variant="outlined"
                    multiline
                    rows={4} // Allows for 4 lines of text
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    InputProps={{
                      sx: {
                        backgroundColor: "#f5f8fd",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={handleSubmit}
                    sx={{
                      backgroundColor: "#054E91", // Primary button color
                      px: 4, // Horizontal padding
                      py: 1.5, // Vertical padding
                      borderRadius: "10px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      fontFamily: "'Roboto', sans-serif",
                      "&:hover": {
                        backgroundColor: "#1F85C0", // Hover effect color
                      },
                    }}
                  >
                    Send
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </motion.div>{" "}
      {/* End of motion.div wrapping the main content */}
    </Box>
  );
};

export default EnquiryForm;
